import * as endpoints from '@App/constants/endpoints';
import interceptor from '../interceptor';
import { get, post, patch, del } from '../util';

const AI = 'ai';
const TRANSCRIPTION = 'transcription';
const SESSION = 'session';
const PROCESS = 'process';
const APPLY = 'apply';
const TEXT = 'text';
const ATTENDANCE = 'attendance';
const SESSIONS = 'sessions';

export const createTranscriptionSession = async ({ header, params }) => {
    const pathUrl = `${endpoints.API_FORMS}/${AI}/${TRANSCRIPTION}/${SESSION}`;
    const axios = interceptor(header);
    return await post(axios, pathUrl, params);
};

export const updateTranscriptionText = async ({ header, sessionId, editedText }) => {
    const pathUrl = `${endpoints.API_FORMS}/${AI}/${TRANSCRIPTION}/${SESSION}/${sessionId}/${TEXT}`;
    const axios = interceptor(header);
    return await patch(axios, pathUrl, { editedText });
};

export const processTranscription = async ({ header, sessionId, params }) => {
    const pathUrl = `${endpoints.API_FORMS}/${AI}/${TRANSCRIPTION}/${SESSION}/${sessionId}/${PROCESS}`;
    const axios = interceptor(header);
    return await post(axios, pathUrl, params);
};

export const applyTranscription = async ({ header, sessionId, params }) => {
    const pathUrl = `${endpoints.API_FORMS}/${AI}/${TRANSCRIPTION}/${SESSION}/${sessionId}/${APPLY}`;
    const axios = interceptor(header);
    return await post(axios, pathUrl, params);
};

export const getTranscriptionSession = async ({ header, sessionId }) => {
    const pathUrl = `${endpoints.API_FORMS}/${AI}/${TRANSCRIPTION}/${SESSION}/${sessionId}`;
    const axios = interceptor(header);
    return await get(axios, pathUrl);
};

export const listTranscriptionByAttendance = async ({ header, medicalRecordsAttendanceId }) => {
    const pathUrl = `${endpoints.API_FORMS}/${AI}/${TRANSCRIPTION}/${ATTENDANCE}/${medicalRecordsAttendanceId}`;
    const axios = interceptor(header);
    return await get(axios, pathUrl);
};

export const listUserTranscriptionSessions = async ({ header, params = {} }) => {
    const queryParams = new URLSearchParams();
    if (params.status) queryParams.append('status', params.status);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.medicalRecordsAttendanceId) queryParams.append('medicalRecordsAttendanceId', params.medicalRecordsAttendanceId);

    const queryString = queryParams.toString();
    const pathUrl = `${endpoints.API_FORMS}/${AI}/${TRANSCRIPTION}/${SESSIONS}${queryString ? `?${queryString}` : ''}`;
    const axios = interceptor(header);
    return await get(axios, pathUrl);
};

export const cancelTranscriptionSession = async ({ header, sessionId }) => {
    const pathUrl = `${endpoints.API_FORMS}/${AI}/${TRANSCRIPTION}/${SESSION}/${sessionId}`;
    const axios = interceptor(header);
    return await del(axios, pathUrl);
};

export const uploadAudio = async ({ header, formData }) => {
    const pathUrl = `${endpoints.API_FORMS}/${AI}/${TRANSCRIPTION}/audio`;
    const axios = interceptor(header);
    return await post(axios, pathUrl, formData);
};

export const correctText = async ({ header, text, templateContent }) => {
    const pathUrl = `${endpoints.API_FORMS}/${AI}/${TRANSCRIPTION}/correct-text`;
    const axios = interceptor(header);
    return await post(axios, pathUrl, { text, templateContent });
};
